@if (options.possibleComponentTypes.length > 1) {
  <div class="search-filter_title">
    <div class="search-filter_title-label">
      {{ 'Filter' | transloco }}
      <span class="search-filter_title-label-count">({{ value.possibleComponentTypes.length }})</span>
    </div>
  </div>

  <div class="search-filter_content">
    @for (component of options.possibleComponentTypes; track component) {
      <button
        aria-label="{{componentTypePropertyMap[component]?.ariaLabel}}"
        class="search-filter_content-button"
        [class.search-filter_content-button--active]="value?.possibleComponentTypes.includes(component)"
        (click)="addOrRemoveComponentType(component)">
        @if (componentTypePropertyMap[component].icon) {
          <mat-icon [icon]="componentTypePropertyMap[component].icon" [iconSize]="16" />
        }
        {{ componentTypePropertyMap[component].translationKey | transloco }}
      </button>
    }
  </div>
}
